export const DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export default { DAYS };

export const EVERYONE = 'Everyone';

export const SERVICE_GROUPS = [
  ['Everyone'],
  ['Children', 0, 11],
  ['Teens', 13, 19],
  ['Youths', 18, 24],
  ['Adults', 18],
  ['Seniors', 65],
  ['Veterans'],
];

export const TAXONOMY_SPECIFIC_ATTRIBUTES = {
  clothingOccasion: 'clothingOccasion',
  wearerAge: 'wearerAge',
  tgncClothing: 'tgncClothing',
  hasHivNutrition: 'hasHivNutrition',
};

export const OCCASIONS = {
  COVID19: 'COVID19',
};

export const DESKTOP_BREAKPOINT = '1224px';
